import React from "react"

import {Col, Grid, PageHeader, Row} from "react-bootstrap"

export default ({ data }) => {
    const page = data.markdownRemark
    return (
        <Grid fluid>
            <Row>
                <Col xs={12}>
                    <PageHeader>
                        {page.frontmatter.title}
                    </PageHeader>
                    <div dangerouslySetInnerHTML={{ __html: page.html }} />
                </Col>
            </Row>
        </Grid>
    )
}

export const query = graphql`
  query MarkdownPageQuery($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      tableOfContents
      frontmatter {
        title
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/templates/markdown.js